import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { toast } from "sonner";

/**
 * /r/:token — patient lands here from a review-request email.
 * We look up the provider and redirect to /listing/{slug}?review=open
 * so the listing auto-opens the write-review dialog.
 */
export default function ReviewRequestRedirect() {
  const { token } = useParams();
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/review-request/${token}`)
      .then(({ data }) => {
        if (data?.provider?.slug) {
          nav(`/listing/${data.provider.slug}?review=open`, { replace: true });
        } else {
          toast.error("Invalid or expired review link");
          nav("/", { replace: true });
        }
      })
      .catch(() => {
        toast.error("Invalid or expired review link");
        nav("/", { replace: true });
      });
  }, [token, nav]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-[#064E3B]" />
    </div>
  );
}
